// extracted by mini-css-extract-plugin
module.exports = {"apiTitle":"ApiTable_apiTitle__jfZLb","tableProperty":"ApiTable_tableProperty__1ias4","tableType":"ApiTable_tableType__217dv"};